import ApiResponse from "@/models/ApiResponse";
import http, { handleApiResponse } from "@/services/http";
import UserSetting, { UserSettingDefaultProps } from "@/models/UserSetting";

/**
 * Felhasználóhoz kötött felületi beállítások (rmgenuser_setting).
 * A userid a szerveren, a bejelentkezett felhasználóból kerül be, ezért itt nem küldjük.
 */

/** Egy beállításnak egy sora legyen: a mentés kulcsa a profilnevet is tartalmazza. */
const defaultProfileName = "Default";

/** A felhasználó összes mentett profilja egy kontroll + típus kulcsra. */
export function loadUserSettings(controlName: string, type: string): Promise<UserSetting[]> {
  const setting: UserSetting = { ...UserSettingDefaultProps, controlName, type };
  return http.post<ApiResponse<UserSetting[]>>("user-setting/get", setting).then(handleApiResponse);
}

/** A mentett érték, vagy undefined, ha a felhasználónak még nincs mentése erre a kulcsra. */
export async function getUserSettingValue<T>(controlName: string, type: string): Promise<T | undefined> {
  const settings = await loadUserSettings(controlName, type);
  if (settings.length === 0) return undefined;

  return JSON.parse(settings[0].userSetting).value as T;
}

/** A válasz "success", ha a mentés (insert vagy update) megtörtént. */
export function setUserSetting(
  controlName: string,
  type: string,
  value: unknown,
  profileName: string = defaultProfileName,
  isDefault = false
): Promise<string> {
  const setting: UserSetting = {
    ...UserSettingDefaultProps,
    controlName,
    type,
    userSetting: JSON.stringify({ value }),
    profileName,
    isDefault,
  };

  return http.post<ApiResponse<string>>("user-setting/set", setting).then(handleApiResponse);
}

/** A válasz "success", ha a profil sora törlődött (nem létező profilra is). */
export function deleteUserSetting(controlName: string, type: string, profileName: string): Promise<string> {
  const setting: UserSetting = { ...UserSettingDefaultProps, controlName, type, profileName };
  return http.post<ApiResponse<string>>("user-setting/delete", setting).then(handleApiResponse);
}
